import { apiFetch } from './api.js';
import { isSupabaseConfigured } from './supabase.js';

export interface ApiKeySummary {
  id: string;
  name: string;
  last4: string;
  scopes: string[];
  createdBy: { id: string; name: string } | null;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface CreateApiKeyResult {
  key: ApiKeySummary;
  secret: string;
}

export const DEVELOPER_DOCS_URL = 'https://docs.parcelengineering.com/developers/';

export function formatApiKeyHint(last4: string): string {
  return `pcl_…${last4}`;
}

export function formatApiKeyTimestamp(iso: string | null): string {
  if (!iso) return 'Never';
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export async function listApiKeys(workspaceSlug: string): Promise<ApiKeySummary[]> {
  if (!isSupabaseConfigured) return [];
  const response = await apiFetch<{ keys: ApiKeySummary[] }>(
    `/workspaces/${encodeURIComponent(workspaceSlug)}/api-keys`,
  );
  return response.keys;
}

export async function createApiKey(
  workspaceSlug: string,
  input: { name: string },
): Promise<CreateApiKeyResult> {
  if (!isSupabaseConfigured) {
    const secret = 'pcl_local-preview-secret-0000';
    return {
      key: {
        id: `preview-key-${Date.now()}`,
        name: input.name,
        last4: secret.slice(-4),
        scopes: ['read'],
        createdBy: null,
        createdAt: new Date().toISOString(),
        lastUsedAt: null,
      },
      secret,
    };
  }
  return apiFetch<CreateApiKeyResult>(`/workspaces/${encodeURIComponent(workspaceSlug)}/api-keys`, {
    method: 'POST',
    body: JSON.stringify({ name: input.name }),
  });
}

export async function revokeApiKey(workspaceSlug: string, keyId: string): Promise<void> {
  if (!isSupabaseConfigured) return;
  await apiFetch(
    `/workspaces/${encodeURIComponent(workspaceSlug)}/api-keys/${encodeURIComponent(keyId)}`,
    { method: 'DELETE' },
  );
}
